import React from "react";
import { currencyUSD } from "../../helpers/forms/formater";
import { Pencil, Trash2 } from "lucide-react";

const Columns = (addUpd) => {
    let columns = [
        {
            id: "short_name",
            name: "Identificador",
            selector: (row) => `${row.short_name}`,
        },
        {
            id: "name",
            name: "Nombre",
            selector: (row) => `${row.name}`,
        },
        {
            id: "last_names",
            name: "Apellidos",
            selector: (row) => `${row.last_names}`,
        },
        {
            id: "sales_quarter",
            name: "Ventas de la 15na",
            selector: (row) => (
                <span className="text-fr-accent font-semibold bg-fr-accent/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.params_quarter ?? 0)}
                </span>
            ),
        },
        {
            id: "sales_month",
            name: "Ventas del mes",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.params_month ?? 0)}
                </span>
            ),
        },
        {
            id: "commission",
            name: "Comisión",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.commission ?? 0)}
                </span>
            ),
        },
        
        {
            id: "acciones",
            name: "Acciones",
            selector: (row) => (
                <div className="flex items-center gap-3">
                    <button
                        className="text-fr-primary hover:text-fr-primary-hover transition"
                        onClick={() => addUpd(row)}
                        title="Editar"
                    >
                        <Pencil size={18} />
                    </button>
                    <button
                        className="text-fr-danger hover:text-red-600 transition"
                        onClick={() => console.log(row)}
                        title="Eliminar"
                    >
                        <Trash2 size={18} />
                    </button>
                </div>
            ),
        },
    ];
    return columns;
};

export default Columns;
